import React, { memo, useCallback } from 'react';

import { Box, Tab, Tabs } from '@mui/material';
import { TabsCDS } from 'app/shared/componentsRestyled/coreDesignSystem/TabsCDS';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { SystemTableTestIds } from '../SystemTable.testIds';

import { DEFAULT_TAB_DEFS } from './TableTabToolbar.constants';
import { tabsStyles, tabStyles } from './ToolbarTab.styles';

const ToolbarTab = ({
  setActiveTab = _.noop,
  onTabChange,
  activeTab,
  tabsDefs = DEFAULT_TAB_DEFS,
}) => {
  const onChange = useCallback((__, value) => setActiveTab(value), [setActiveTab]);

  return (
    <Box className="tool__break-word w-full" data-testid={SystemTableTestIds.TAB_TOOLBAR}>
      <Tabs
        data-testid={SystemTableTestIds.TOOLBAR_TABS}
        indicatorColor="primary"
        sx={tabsStyles}
        textColor="inherit"
        value={activeTab}
        variant="scrollable"
        onChange={onTabChange || onChange}
      >
        {tabsDefs.map(({ label, value }, index) => (
          <Tab wrapped key={value || index} label={label} sx={tabStyles} value={value || index} />
        ))}
      </Tabs>
    </Box>
  );
};

const ToolbarTabCDS = ({
  setActiveTab = _.noop,
  onTabChange,
  activeTab,
  tabsDefs = DEFAULT_TAB_DEFS,
}) => {
  const onChange = useCallback((__, value) => setActiveTab(value), [setActiveTab]);

  return (
    <Box className="tool__break-word w-full" data-testid={SystemTableTestIds.TAB_TOOLBAR}>
      <TabsCDS
        data-testid={SystemTableTestIds.TOOLBAR_TABS}
        tabs={tabsDefs}
        value={activeTab}
        variant="scrollable"
        onChange={onTabChange || onChange}
      />
    </Box>
  );
};

ToolbarTab.propTypes = {
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setActiveTab: PropTypes.func,
  tabsDefs: PropTypes.array,
  onTabChange: PropTypes.func,
};

ToolbarTabCDS.propTypes = ToolbarTab.propTypes;

const MemoizedToolbarTab = memo(ToolbarTab);
MemoizedToolbarTab.CDS = memo(ToolbarTabCDS);

export default MemoizedToolbarTab;
